const ACTIVE_ACCOUNT_SESSION_PREFIX = "geoanalytics.activeAccount.";

function getActiveAccountSessionKey(uid: string) {
  return `${ACTIVE_ACCOUNT_SESSION_PREFIX}${uid}`;
}

export function markAccountActiveInSession(uid: string) {
  try {
    sessionStorage.setItem(getActiveAccountSessionKey(uid), "true");
  } catch {
    // Session storage can be unavailable in restricted browser modes.
  }
}

export function clearAccountActiveInSession(uid: string) {
  try {
    sessionStorage.removeItem(getActiveAccountSessionKey(uid));
  } catch {
    // Session storage can be unavailable in restricted browser modes.
  }
}

export function isAccountActiveInSession(uid: string) {
  try {
    return sessionStorage.getItem(getActiveAccountSessionKey(uid)) === "true";
  } catch {
    return false;
  }
}

export function hasActiveAccountAccess(uid: string | null | undefined, isActive: boolean) {
  return Boolean(isActive || (uid && isAccountActiveInSession(uid)));
}
